<template>
  <div class="home-container">
    <!-- 顶部欢迎栏（紧凑） -->
    <div class="top-bar">
      <div class="top-left">
        <div class="top-greeting">你好，{{ userInfo?.name || '管理员' }}</div>
        <div class="top-meta">{{ currentDate }} {{ festivalGreeting }} · 在线 {{ onlineTime }}<span v-if="lastLogin"> · 上次登录 {{ lastLogin }}</span></div>
      </div>
    </div>

    <!-- 核心指标左 + 快捷入口右 -->
    <el-row :gutter="20" style="margin-bottom:24px">
      <el-col :span="14">
        <el-row :gutter="12" style="margin-bottom:8px">
          <el-col :span="6"><div class="num-card" @click="goTo('/membership/users')">
            <div class="num-value">{{ stats.total_users }}</div>
            <div class="num-label">注册用户</div>
            <div class="num-sub">今日 +{{ stats.today_new_users }}</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card" @click="goTo('/membership/levels')">
            <div class="num-value">{{ stats.member_users }}</div>
            <div class="num-label">会员数</div>
            <div class="num-sub">有等级用户</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card" @click="goTo('/orders/mall')">
            <div class="num-value">{{ stats.mall_orders }}</div>
            <div class="num-label">商城订单</div>
            <div class="num-sub">待处理 {{ stats.pending_orders }}</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card" @click="goTo('/activities/list')">
            <div class="num-value">{{ stats.total_registrations }}</div>
            <div class="num-label">报名</div>
            <div class="num-sub">活动报名数</div>
          </div></el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="6"><div class="num-card" @click="goTo('/orders/hotel')">
            <div class="num-value">{{ stats.hotel_orders }}</div>
            <div class="num-label">酒店订单</div>
            <div class="num-sub">宠境酒店</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card">
            <div class="num-value">-</div>
            <div class="num-label">民宿订单</div>
            <div class="num-sub">暂无数据</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card" @click="goTo('/orders/daycare')">
            <div class="num-value">{{ stats.daycare_orders }}</div>
            <div class="num-label">日托订单</div>
            <div class="num-sub">宠境日托</div>
          </div></el-col>
          <el-col :span="6"><div class="num-card" @click="goTo('/orders/park')">
            <div class="num-value">{{ stats.park_orders }}</div>
            <div class="num-label">乐园订单</div>
            <div class="num-sub">宠境乐园</div>
          </div></el-col>
        </el-row>
      </el-col>
      <el-col :span="10">
        <div class="quick-card">
          <div class="quick-header">
            <span>我的快捷入口</span>
            <span class="quick-edit" @click="showCustomize = true">✎ 自定义</span>
          </div>
          <div class="quick-grid">
            <div class="quick-item" v-for="item in visibleLinks" :key="item.path" @click="goTo(item.path)">
              <el-icon :size="20" :color="item.color"><component :is="item.icon" /></el-icon>
              <span>{{ item.label }}</span>
            </div>

          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 图表行：注册趋势 + 活动趋势 -->
    <el-row :gutter="20" style="margin-bottom:20px">
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">用户注册趋势</span><span style="float:right;font-size:12px;color:#909399">近7天</span></template>
          <div class="chart-box"><div class="bar-chart">
            <div class="bar-item" v-for="(item, i) in userTrends" :key="i">
              <div class="bar-bar" :style="{ height: barH(item.count) + '%' }"><span class="bar-num">{{ item.count }}</span></div>
              <div class="bar-label">{{ item.date.slice(5) }}</div>
            </div>
          </div></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">活动报名趋势</span><span style="float:right;font-size:12px;color:#909399">近7天</span></template>
          <div class="chart-box"><div class="bar-chart">
            <div class="bar-item" v-for="(item, i) in regTrends" :key="i">
              <div class="bar-bar bar-bar--green" :style="{ height: barH2(item.count) + '%' }"><span class="bar-num">{{ item.count }}</span></div>
              <div class="bar-label">{{ item.date.slice(5) }}</div>
            </div>
          </div></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表行：订单分布 -->
    <el-row :gutter="20" style="margin-bottom:20px">
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">订单状态分布</span></template>
          <div class="pie-list">
            <div class="pie-item" v-for="s in orderStatusList" :key="s.label">
              <span class="pie-dot" :style="{ background: s.color }"></span>
              <span class="pie-label">{{ s.label }}</span>
              <span class="pie-bar-bg"><span class="pie-bar-fill" :style="{ width: s.pct+'%', background: s.color }"></span></span>
              <span class="pie-pct">{{ s.pct }}%</span>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <!-- 自定义快捷入口弹窗 -->
    <el-dialog v-model="showCustomize" title="自定义快捷入口" width="70%" top="5vh">
      <div style="margin-bottom:12px">
        <div style="color:#909399;font-size:13px;margin-bottom:8px">勾选你想在首页展示的快捷入口（最多选8个）</div>
        <div style="display:flex;flex-wrap:wrap;gap:6px;min-height:28px" v-if="selectedPaths.length > 0">
          <el-tag v-for="p in selectedPaths" :key="p" closable size="small" @close="removePath(p)" :type="getTagType(p)">{{ getLabel(p) }}</el-tag>
        </div>
        <div style="color:#ccc;font-size:12px" v-else>暂未选择，请在下方勾选</div>
      </div>
      <el-checkbox-group v-model="selectedPaths" :max="8">
        <div class="group-card" v-for="(items, group) in groupedLinks" :key="group">
          <div class="group-title">{{ group }}</div>
          <div class="group-items">
            <div class="group-item" v-for="item in items" :key="item.path">
              <el-checkbox :label="item.path">
                <el-icon :size="16" :color="item.color" style="vertical-align:middle;margin-right:4px"><component :is="item.icon" /></el-icon>
                {{ item.label }}
              </el-checkbox>
            </div>
          </div>
        </div>
      </el-checkbox-group>
      <template #footer>
        <el-button @click="showCustomize = false">取消</el-button>
        <el-button type="primary" @click="saveCustomize">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { useMenuStore } from '../stores/menu';
import * as authApi from '../api/auth';
import * as statApi from '../api/statistics';
import { Lunar } from 'lunar-javascript';

export default {
  name: 'Home',
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const userInfo = ref(authStore.userInfo);
    const currentDate = ref('');
    const festivalGreeting = ref('祝您工作愉快！');
    const onlineTime = ref('00:00');
    const lastLogin = ref('');
    const stats = ref({ total_users:0, today_new_users:0, member_users:0, total_pet_archives:0, total_orders:0, pending_orders:0, mall_orders:0, hotel_orders:0, daycare_orders:0, park_orders:0, total_activities:0, total_registrations:0 });
    const userTrends = ref([]);
    const regTrends = ref([]);
    const orderStatusData = ref([]);
    const showCustomize = ref(false);
    const selectedPaths = ref([]);

    const menuStore = useMenuStore();
    // 图标映射
    const iconColors = ['#409eff','#67c23a','#e6a23c','#f56c6c','#9b59b6','#1abc9c','#e67e22','#95a5a6','#2ecc71','#3498db','#e74c3c','#34495e'];
    const pathIconMap = {
      '/membership/users': 'User', '/membership/levels': 'Star',
      '/pet-profile/archives': 'Collection', '/pet-profile/entry': 'Edit',
      '/orders/mall': 'List', '/orders/hotel': 'List', '/orders/park': 'List', '/orders/daycare': 'List',
      '/activities/list': 'Calendar', '/mall/products': 'ShoppingCart',
      '/training/content': 'Files', '/training/category': 'Tickets',
      '/content/banners': 'Goods', '/content/working-dogs': 'ChatDotSquare',
      '/statistics/users': 'DataAnalysis', '/statistics/orders': 'DataAnalysis',
      '/statistics/pets': 'DataAnalysis', '/statistics/favorites': 'DataAnalysis',
      '/settings': 'Setting', '/admin-users/list': 'UserFilled',
      '/users/balances': 'Wallet', '/users/checkins': 'List',
      '/users/clerks': 'UserFilled', '/users/verifications': 'List',
    };
    // 从菜单树中提取所有叶子菜单项
    const extractLeafMenus = (menus, parentLabel = '') => {
      const result = [];
      if (!menus || !Array.isArray(menus)) return result;
      for (const m of menus) {
        if (!m) continue;
        if ((m.type === 'item' || m.type === 'menu') && m.path) {
          result.push({ path: m.path, label: m.label, group: parentLabel, icon: pathIconMap[m.path] || 'Menu', color: iconColors[result.length % iconColors.length] });
        }
        if (m.type === 'submenu' && m.children) {
          result.push(...extractLeafMenus(m.children, m.label));
        }
      }
      return result;
    };
    const allLinks = computed(() => {
      const menus = menuStore.currentMenus || [];
      return Array.isArray(menus) ? extractLeafMenus(menus) : [];
    });

    // 按一级菜单分组
    const groupedLinks = computed(() => {
      const map = {};
      const links = allLinks.value || [];
      for (const item of links) {
        if (!item || !item.path) continue;
        const group = item.group || '其他';
        if (!map[group]) map[group] = [];
        map[group].push(item);
      }
      return map;
    });

    const visibleLinks = computed(() => allLinks.value.filter(item => selectedPaths.value.includes(item.path)));
    const orderStatusList = computed(() => {
      const arr = Array.isArray(orderStatusData.value) ? orderStatusData.value : [];
      const total = arr.reduce((a, b) => a + (b.count || 0), 0) || 1;
      const colors = ['#409eff', '#67c23a', '#e6a23c', '#f56c6c', '#909399'];
      return arr.map((item, i) => ({ ...item, color: colors[i % colors.length], pct: ((item.count / total) * 100).toFixed(1) }));
    });

    const barH = (count) => {
      const arr = userTrends.value || [];
      const max = Math.max(...arr.map(t => t.count || 0), 1);
      return Math.max(4, (count / max) * 100);
    };
    const barH2 = (count) => {
      const arr = regTrends.value || [];
      const max = Math.max(...arr.map(t => t.count || 0), 1);
      return Math.max(4, (count / max) * 100);
    };
    const getLabel = (path) => { const item = allLinks.value.find(l => l.path === path); return item ? item.label : path; };
    const getTagType = (path) => { const idx = selectedPaths.value.indexOf(path); return ['','success','warning','info','danger','','',''][idx] || ''; };
    const removePath = (path) => { selectedPaths.value = selectedPaths.value.filter(p => p !== path); };
    const goTo = (path) => router.push(path);

    const getFestivalGreeting = (date) => {
      const lunar = Lunar.fromDate(date);
      const m = date.getMonth() + 1, d = date.getDate();
      const lm = lunar.getMonth(), ld = lunar.getDay();
      if (m === 1 && d === 1) return '元旦快乐！';
      if (m === 5 && d === 1) return '劳动节快乐！';
      if (m === 10 && d === 1) return '国庆节快乐！';
      if (lm === 1 && ld === 1) return '春节快乐！';
      if (lm === 5 && ld === 5) return '端午节快乐！';
      if (lm === 8 && ld === 15) return '中秋节快乐！';
      return '祝您工作愉快！';
    };

    const fetchData = async () => {
      try {
        const [dashRes, overviewRes] = await Promise.all([
          authApi.getDashboardData(),
          statApi.getOverview().catch(() => ({ data: {} })),
        ]);
        if (dashRes.code === 200 && dashRes.data) {
          const d = dashRes.data;
          stats.value = d.stats || stats.value;
          userTrends.value = d.user_trends || [];
          onlineTime.value = d.online_time || '00:00';
          lastLogin.value = d.last_login_at ? d.last_login_at.substring(0, 16) : '';
        }
        const ov = (overviewRes && overviewRes.data) ? overviewRes.data : (overviewRes || {});
        regTrends.value = ov.reg_trends || [];
        orderStatusData.value = ov.order_status || [];
        if (ov.stats) {
          stats.value = { ...stats.value, ...ov.stats };
        }
      } catch (e) { console.error('获取首页数据失败:', e); }
    };

    const loadQuickLinks = async () => {
      selectedPaths.value = allLinks.value.slice(0, 8).map(l => l.path);
      try {
        const r = await statApi.getQuickLinks();
        if (Array.isArray(r) && r.length > 0) {
          selectedPaths.value = r.filter(p => allLinks.value.some(l => l.path === p));
        }
      } catch {}
    };

    const saveCustomize = async () => {
      try { await statApi.saveQuickLinks(selectedPaths.value); showCustomize.value = false; } catch {}
    };

    onMounted(async () => {
      const now = new Date();
      currentDate.value = now.toLocaleDateString('zh-CN', { year:'numeric', month:'long', day:'numeric', weekday:'long' });
      festivalGreeting.value = getFestivalGreeting(now);
      fetchData();
      // 等待菜单加载完成后再初始化快捷入口
      if (!menuStore.currentMenus || menuStore.currentMenus.length === 0) {
        await menuStore.initMenus();
      }
      loadQuickLinks();
    });

    return {
      userInfo, currentDate, festivalGreeting, onlineTime, lastLogin,
      stats, userTrends, regTrends, orderStatusList,
      allLinks, visibleLinks, showCustomize, selectedPaths, groupedLinks,
      barH, barH2, goTo, saveCustomize, getLabel, getTagType, removePath,
    };
  },
};
</script>

<style scoped>
.home-container { padding: 20px; }

/* 顶部紧凑欢迎栏 */
.top-bar { padding: 12px 16px; background: #fff; border-radius: 10px; margin-bottom: 20px; border: 1px solid #e4e7ed; }
.top-greeting { font-size: 18px; font-weight: 600; color: #303133; }
.top-meta { font-size: 12px; color: #909399; margin-top: 4px; }

/* 数字指标卡 */
.num-card { background: #fff; border-radius: 10px; padding: 16px 6px; text-align: center; cursor: pointer; border: 1px solid #e4e7ed; transition: transform .2s, box-shadow .2s; }
.num-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,.08); }
.num-value { font-size: 28px; font-weight: 700; color: #409eff; line-height: 1.2; }
.num-label { font-size: 13px; color: #606266; margin-top: 4px; }
.num-sub { font-size: 11px; color: #909399; margin-top: 2px; }

/* 快捷入口 */
.quick-card { background: #fff; border-radius: 10px; padding: 14px; border: 1px solid #e4e7ed; height: 100%; box-sizing: border-box; }
.quick-header { display: flex; justify-content: space-between; align-items: center; font-weight: 600; font-size: 14px; color: #303133; margin-bottom: 8px; }
.quick-edit { font-size: 12px; color: #909399; cursor: pointer; font-weight: 400; }
.quick-edit:hover { color: #409eff; }
.chart-box { padding: 10px 0; }
.bar-chart { display: flex; align-items: flex-end; justify-content: space-around; height: 200px; }
.bar-item { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; height: 100%; }
.bar-bar { width: 40px; background: linear-gradient(180deg, #409eff, #79bbff); border-radius: 6px 6px 2px 2px; min-height: 8px; display: flex; align-items: flex-start; justify-content: center; padding-top: 4px; transition: height .5s; }
.bar-bar--green { background: linear-gradient(180deg, #67c23a, #95d475); }
.bar-num { font-size: 12px; color: #fff; font-weight: 600; }
.bar-label { font-size: 12px; color: #909399; margin-top: 8px; }
.pie-list { padding: 6px 12px; }
.pie-item { display: flex; align-items: center; padding: 10px 0; border-bottom: 1px solid #f5f5f5; gap: 10px; }
.pie-item:last-child { border-bottom: none; }
.pie-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.pie-label { width: 70px; font-size: 13px; color: #606266; }
.pie-bar-bg { flex: 1; height: 8px; background: #f0f0f0; border-radius: 4px; overflow: hidden; }
.pie-bar-fill { display: block; height: 100%; border-radius: 4px; transition: width .6s; }
.pie-pct { width: 40px; text-align: right; font-size: 12px; color: #909399; }
.quick-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 6px 0; }
.quick-item { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 12px 0; border-radius: 12px; cursor: pointer; transition: background .2s; }
.quick-item:hover { background: #f0f5ff; }
.quick-item span { font-size: 12px; color: #606266; }
.quick-item--add { border: 1px dashed #ddd; background: #fafafa; }
.quick-item--add:hover { border-color: #409eff; }
.group-card { border: 1px solid #eee; border-radius: 8px; padding: 12px; margin-bottom: 12px; background: #fafafa; }
.group-title { font-size: 13px; font-weight: 600; color: #303133; margin-bottom: 8px; padding-bottom: 6px; border-bottom: 1px solid #e4e7ed; }
.group-items { display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px; }
.group-item { padding: 2px 0; }
</style>
